import type { TemplateRef } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  viewChild,
} from '@angular/core';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-tab',
  imports: [],
  templateUrl: './tab.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  readonly hidden = input<boolean>(false);
  readonly tabId = input<string>('');
  readonly label = input<string>('');
  readonly icon = input<IconProp | undefined>(undefined);
  readonly iconMessage = input<number | string | undefined>(undefined);
  readonly path = input<string>('');
  readonly template = viewChild<TemplateRef<unknown>>('templateRef');
}
